import { i18n, isInLoadedLang, setI18nLanguage, loadLanguage, insertSectionToLanguage } from '../../../i18n/index';
import * as types from '../types';
import { I18nService } from '../../../services/i18n';




export const i18nActions = {
  async [types.UPDATE_SYSTEM_LANGUAGE]({ commit, state }, payload) {

    if (!payload) {
      return;
    }

    const lang = payload.value;

    if (isInLoadedLang(lang)) {
      setI18nLanguage(lang);
      commit(types.SET_SYSTEM_LANGUAGE, payload)
      return;
    }

    let langData = {};
    console.log({
      'actions.js:27 state.systemLanguage.loadedSections': state.systemLanguage.loadedSections,
      sections: state.systemLanguage.sections,
      lang,
      i18n: i18n.messages,
      "(state.systemLanguage.loadedSections[lang] || [])": (state.systemLanguage.loadedSections[lang] || [])
    });

    for (let section of state.systemLanguage.sections) {
      if ((state.systemLanguage.loadedSections[lang] || []).includes(section)) {
        continue;
      }
      if (lang != 'keys') {
        const i18nData = await I18nService.getLanguageDict(payload.value, section);
        console.log({'actions.js:37 i18nData' : i18nData});
        langData = {
          ...langData,
          ...(i18nData || {}),
        }
      } else {
        langData = {
          ...langData,
          ...getKeyKeyObject(state),
        }
      }
    }

    console.log({lang, langData });

    loadLanguage(lang, langData);

    commit(types.SET_SYSTEM_LANGUAGE, payload);
  },
  async [types.INSERT_SYSTEM_LANGUAGE_SECTION]({ commit, state }, payload) {
    const sections = payload || ['main'];

    let langData = {};

    console.log({ 'actions.js:53 state.systemLanguage.sections': state.systemLanguage.sections });
    console.log(sections, payload, state.systemLanguage);
    for (let section of sections) {
      if (state.systemLanguage.sections.includes(section)) {
        continue;
      }
      if (state.systemLanguage.locale != 'keys') {
        const i18nData = await I18nService.getLanguageDict(state.systemLanguage.locale, section);
        langData = {
          ...langData,
          ...(i18nData || {}),
        }
        console.log({'actions.js:69 langData' : langData});
      } else {
        langData = {
          ...langData,
          ...getKeyKeyObject(state),
        }
      }
    }
    // console.log({ langData });

    // OLD i18n Response had different Structure - Hence the complicated old code. Now its much better

    // const iDict = JSON.parse(langData.i18nDict);
    const iDict = langData;
    // const language = langData.lang;
    const lang = state.systemLanguage.locale;

    // const langObject = iDict.reduce((accm, obj) => {
    //   accm[obj.textkey] = obj[language];
    //   return accm;
    // }, {});

    // loadLanguage(lang, langObject);
    insertSectionToLanguage(lang, langData);

    console.log({'actions.js:99 sections' : sections});
    commit(types.INSERT_SYSTEM_LANGUAGE_SECTION, sections);
  }
};


// take first data of i18n.messages
// and make a object with key: key
const getKeyKeyObject = (state) => {
  const keyKeyObject = {};
  const keys = i18n.messages[Object.keys(i18n.messages)[0]];
  console.log({'actions.js:110 i18n.messages' : i18n.messages});
  console.log({'actions.js:110 keys' : keys});
  for (let key in keys) {
    // Key preceeded by a green key unicode character and a red key unicode character
    keyKeyObject[key] = `🔑${key}`;
  }
  return keyKeyObject;
}